module.exports = __webpack_public_path__ + "static/media/training_4_somatic_movement.e2764688.webp";